/**
 * The company the session works in, in the app bar (SB-321). A link to its page, where the
 * members are. Shown only while sign-in is enforced and the session works in a company.
 */
import {Link as RouterLink} from 'react-router-dom';
import {Box, Button, Tooltip} from '@mui/material';
import {Business as BusinessIcon} from '@mui/icons-material';

import {useAuth} from '../auth/AuthContext';

export default function CompanyBadge() {
    const {authEnabled, user, company} = useAuth();
    if (!authEnabled || !user || !company) return null;
    return (
        <Tooltip title="Firmaet du jobber i">
            <Button
                component={RouterLink}
                to="/company"
                color="inherit"
                size="small"
                startIcon={<BusinessIcon fontSize="small"/>}
                sx={{textTransform: 'none', minWidth: 0, maxWidth: {xs: 150, sm: 260}, mr: 0.5, flexShrink: 1}}
            >
                <Box component="span" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                    {company.name || 'Firma'}
                </Box>
            </Button>
        </Tooltip>
    );
}
